export function getDriveURL(driveId: string) {
  return `${window.location.origin}/d/${driveId}`
}

export function getAuthenticatedDriveURL(driveId: string, haToken: string) {
  return `${getDriveURL(driveId)}?_ha=${haToken}`
}

export function getAlbumURL(driveId: string, albumId: string) {
  return `${getDriveURL(driveId)}/${albumId}`
}

/**
 * Path an installed home screen icon opens: the drive (or album) plus the auth
 * token, so the installed app is logged in even when it does not share the
 * browser's storage (iOS). `utm_source` marks launches coming from the icon.
 */
export function getHomescreenPath(driveId: string, albumId?: string | null, haToken?: string | null) {
  const basePath = albumId ? `/d/${driveId}/${albumId}` : `/d/${driveId}`
  const params = new URLSearchParams()
  if (haToken) {
    params.set('_ha', haToken)
  }
  params.set('utm_source', 'home-icon')
  return `${basePath}?${params.toString()}`
}

export function getAPIUrl(path: string) {
  return `${import.meta.env.VITE_PUBLIC_API_URL}/${path}`
}
